import Resource from "lib/jsonApi/Resource";
import { LicenseAttributes } from "types/licenses";

function getLicense(licenseArray?: Resource<LicenseAttributes>[]): Resource<LicenseAttributes> | undefined {
  if (!licenseArray || !Array.isArray(licenseArray) || licenseArray.length === 0) {
    return undefined;
  }
  return licenseArray.sort((a, b) => Number(a.attributes?.price) - Number(b.attributes?.price))[licenseArray.length - 1];
}

export default getLicense;
